import { render, staticRenderFns } from "./form-invite-user-setting.vue?vue&type=template&id=2ba01487&"
import script from "./form-invite-user-setting.vue?vue&type=script&lang=js&"
export * from "./form-invite-user-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports